import { useState, useEffect } from "react";
import swal from 'sweetalert2';
import * as helper from '../global/helper';
import { getFnbMenuSubCategoryByCategoryID, postFnbMenuSubCategory } from "../api/fnbAPI";

const SubcategoryBlock = (props) => {
    const {menu} = props

    const [allSubcategories,   setAllSubcategories]     = useState([]);
    const [newSubcategory,     setNewSubcategory]       = useState({CategoryID: menu.ID, Active: "Y"});
    const [isEdit,             setIsEdit]               = useState(false);

    useEffect(() => {
        if(menu){
            fetchSubcategoryByMenuD(menu.ID);
            AllowSortable()
        }
    },[menu]);

    const dataHandler = (field,value) => setNewSubcategory(d => ({...d, [field]: value}));

    const editHandler = (id) => {
        setIsEdit(true);
        const d = allSubcategories.find(a => a.ID == id);
        setNewSubcategory(d)
    };

    const postSubcategory = async() => {
        const btn  =  (!isEdit) ? $('#btnAdd') : $("#btnUpdate");
        const form = $('#addBlockForm');

        form.validate({
            rules: { txtName: { required: true }},
            messages: { txtName : { required: "Please enter subcategory name" }}
        });

        if (!form.valid()) return;

        helper.StartProcessing(btn);
        try {
            if(!isEdit) newSubcategory.Index = allSubcategories.length + 1;       
            newSubcategory.CategoryID = menu.ID;

            saveBlocks([newSubcategory]);                  
            
            helper.StopProcessing(btn);                  
            if (newSubcategory.ID) {            
                swal.fire({
                    toast: true,
                    icon: 'success',
                    titleText: 'Subcategory updated successfully!',
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 3500,  
                    onOpen: () => swal.hideLoading()                                     
                });
            }else{
                swal.fire({
                    icon: 'success',
                    titleText: 'Subcategory added successfully!',
                    showConfirmButton: false,
                    timer: 3500,
                    onOpen: () => swal.hideLoading()    
                });
                
            }
            
            //Clear State ->
            clearAction();
        } catch (err) {
            helper.StopProcessing(btn);
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return;
        }
    };

    const saveBlocks = async(subcategory) => {
        if(subcategory.length <= 0) return;
        try {
            swal.fire({ titleText: 'Loading', text: 'Please Wait...', showConfirmButton: false, onOpen: () => swal.showLoading() });
            const res = await postFnbMenuSubCategory(subcategory);          
            setAllSubcategories(res);
                    
            swal.close();
        } catch (err) {
            swal.close()
            swal.fire({
                icon                  : 'error',
                titleText             : 'Error!',
                text                  : err.message,
                buttonsStyling        : false,
                confirmButtonClass    : 'btn btn-brand',
            });
            return; 
        }
    };

    const fetchSubcategoryByMenuD = async(id) => {
        try {
            const master = await getFnbMenuSubCategoryByCategoryID(id)
            setAllSubcategories(master);
            
        } catch (err) {
            swal.fire({ icon :'error', titleText : err.message })

        }
    };

    //Sorting -->
    const AllowSortable =() =>{

        const config = (event, ui) =>{
            const ids = [];
            $('#table-block > tbody > .dragableRow').each((i,e) => ids.push( $(e).attr('data-id')));
            sortAndSave(ids);   
        }

        window.sortInit('#table-block tbody', config);    
    };

    const sortAndSave = (param)=> {
        if(param.length <= 0) return;      
        let subcategories = [];        

        setAllSubcategories( d => {
            const sortedSubcategories = [];
            
            for (const [i,id] of Object.entries(param)) {
                let f = d.find( a => a.ID == id);
                if(!!f){
                    f.Index = parseInt(i)+1;                    
                    sortedSubcategories.push(f);
                }
            }

            subcategories = sortedSubcategories;
            return d;
        });
                    
        if(subcategories.length > 0) saveBlocks(subcategories);                              
    };

    const clearAction = () => {       
        setNewSubcategory({CategoryID: menu.ID, Active: "Y"});
        setIsEdit(false);
    };

    const onCheck = async(value) => {
        saveBlocks([value]);                  

    };
    
    return(
        <>
            <div className="kt-portlet__body padding-t20 padding-b0">
                <form className="kt-form sticky margin-b10 padding-t15 padding-b10 bg-white" id="addBlockForm" >                
                    <div id="ControlHolder" className="kt-form kt-form--label-right padding-10 bv-form padding-l150" role="form">
                        <div className="form-group row mb-0">
                            <label className="col-form-label col-sm-3 text-right"> Name </label>
                            <div className="col-xl-3 col-sm-3">
                                <div className="input-group timepicker">
                                    <input 
                                        id="txtName" name="txtName" type="text" className="form-control" 
                                        value={ newSubcategory.Name || '' }
                                        onChange={({target}) => dataHandler("Name", target.value)} 
                                    />
                                </div>                                      
                            </div>
                            <div className="col-sm-3">
                                {(!isEdit) ? (
                                    <button id="btnAdd" type="button" className={`btn btn-label-brand d-inline-block margin-0`} onClick={postSubcategory} ><i className="la la-plus"></i> Add </button>
                                ):(
                                    <div className="btn-group">
                                        <button id="btnUpdate" type="button" className={`btn btn-label-success d-inline-block margin-0`} onClick={postSubcategory} > Update </button>
                                        <button id="btnCancel" type="button" className="btn btn-secondary" onClick={clearAction}> <i className="la la-times ml-1 font-16" > </i> </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </form>
                <table id="table-block" className="table table-bordered table-hover margin-b30">
                    <thead className="light-grey-background">
                        <tr>
                            <th  width="60%" > Name </th>
                            <th className="text-center" width="10%" > Active </th>
                            <th  width="10%" >  </th>
                        </tr>
                    </thead>
                    <tbody>
                        {(allSubcategories.length > 0 )?
                            allSubcategories.map((t,i) => {
                                return (
                                    <tr className="dragableRow" key={t.ID} data-id={t.ID}>
                                        <td width="60%">{t.Name}</td>
                                        <td className="text-center" width="10%">
                                            <span className="kt-switch kt-switch--icon">
                                                <label>
                                                    <input 
                                                        id="chkActive" 
                                                        name="chkActive" 
                                                        type="checkbox" 
                                                        defaultChecked={t.Active == 'N' ? '' : 'checked'}
                                                        onChange={(event) => onCheck({...t, Active: event.target.checked ? 'Y' : 'N'})} 
                                                    />
                                                    <span></span>
                                                </label>
                                            </span>
                                        </td>
                                        <td className="text-center" width="10%">
                                            <button type="button" disabled={isEdit} className="btn btn-outline-info btn-elevate btn-circle btn-icon btn-xs btn-block-edit" onClick={() => editHandler(t.ID)}><i className="flaticon2-edit"></i></button>
                                        </td>
                                    </tr>
                                )
                            }):
                            (
                            <tr>
                                <td colSpan={3}> 
                                    <div className="padding-10"> 
                                        <h5 className="text-center text-muted"> No Subcategories..! </h5> 
                                    </div>
                                </td>
                            </tr>
                            )
                        }
                    </tbody>
                </table>
            </div>
        </>
    )
};

export default SubcategoryBlock;